import { ComponentProps } from 'react';
import {
  withDesktopPadding,
  WithDesktopPaddingProps,
  withPadding,
  WithPaddingProps,
  withTabletPadding,
} from 'style-utils/dimensionsMixins';
import { Col, Row } from 'styled-bootstrap-grid';
import styled from 'styled-components';

export type ColWithPaddingProps = WithPaddingProps &
  WithDesktopPaddingProps &
  ComponentProps<typeof Col>;

export type RowWithPaddingProps = WithPaddingProps &
  WithDesktopPaddingProps &
  ComponentProps<typeof Row>;

export const ColWithPadding = styled(Col)<ColWithPaddingProps>`
  && {
    ${withPadding};
    ${withTabletPadding}
    ${withDesktopPadding};
  }
`;

export const RowWithPadding = styled(Row)<RowWithPaddingProps>`
  && {
    ${withPadding};
    ${withDesktopPadding};
  }
`;
